import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const calendar_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M4.5,6.51 L19.5,6.51 L19.5,17.51 L4.5,17.48 L4.5,6.51 Z M4.5,9.5197
        L19.5,9.5197 M13,11.4997 L17.98,11.4997 M6,13.4997 L11,13.4997 M6,15.4997 L11,15.4997 M13,13.4997
        L18,13.4997 M13,15.4997 L18,15.4997 M7.5,7.9997 L7.5,4.9997 M16.5,7.9997 L16.5,4.9997"
      />
    </svg>
  );
};
